import type { SelectorDefinition } from '@exodus/redux-dependency-injection';

import type { Nft, NftAttribute } from '@/ui/types';
import type { PlaygroundSbt } from '../types.js';

const resultFunction = (
  loaded: boolean,
  data: PlaygroundSbt | null,
): Nft | undefined => {
  if (!loaded || !data?.claimed) {
    return;
  }

  return {
    id: `${data.id}`,
    name: data.metadata.name,
    description: data.metadata.description,
    image: data.metadata.image,
    rawImageUrl: data.metadata.image,
    attributes: data.metadata.attributes.map(
      ({ trait_type: trait, value }) =>
        ({
          trait,
          value,
        }) satisfies NftAttribute,
    ),
    network: data.metadata.network,
    collectionName: data.metadata.collectionName,
    collectionSymbol: '',
    contractAddress: data.metadata.contractAddress,
    tokenId: `${data.id}`,
    number: data.id,
    owner: '',
    spamScore: 0,
  };
};

const claimedDefinition = {
  id: 'claimed',
  resultFunction,
  dependencies: [{ selector: 'loaded' }, { selector: 'data' }],
} as const satisfies SelectorDefinition;

const selectorDefinitions = [claimedDefinition];

export default selectorDefinitions;
